<template>
    <fieldset :disabled="loading">
        <div v-if="data" class="roundbox">
            <div class="rbcontent head">
                <button type="button" class="btn btn-outline-secondary mlxxs float-right" @click="clone" v-show="userActions.CanClone" :title="translate('job.createSimilarJobTitle')">{{translate('job.createSimilarJob')}}</button>
                <button type="button" class="btn btn-outline-secondary mlxxs float-right" style="margin-right:8px;" @click="revise" v-show="userActions.CanRevise" :title="translate('job.reviseTitle')">{{translate('job.revise')}}</button>
                <h2>{{data.Title}}</h2>
                <!-- <div class="row" v-if="false">
                    <div class="col">
                        <div class="btn-group" role="group" aria-label="Basic example">
                            <button type="button" @click="resendNotification()" ref="resendNotification" class="btn btn-outline-secondary">Yeniden Bildirim Gönder</button>
                        </div>
                    </div>
                </div> -->
            </div>
            <div class="">
                <div class="row no-gutters job-container">
                    <div class="col">
                        <div class="rbcontent">
                            <div class="alert alert-warning" v-if="data.LastRevision">
                                {{translate('job.newRevisionAvailable')}}:
                                <router-link :to="{ name: $route.name, params: { id : data.LastRevision.Id }  }">{{ data.LastRevision.TrackingNo | trackingNo }}</router-link>
                            </div>

                            <table class="table table-borderless table-sm ozet">
                                <tbody>
                                    <tr>
                                        <td style="width:150px;">{{translate('reportFilter.trackingNo')}}</td>
                                        <td style="width:1px;">:</td>
                                        <td style="font-weight:bold;">{{data.TrackingNo | trackingNo}}</td>
                                    </tr>
                                    <tr v-if="data.DocumentNumber">
                                        <td>{{translate('draft.docNo')}}</td>
                                        <td>:</td>
                                        <td>{{data.DocumentNumber }}</td>
                                    </tr>
                                    <tr v-if="data.IncomingDocId">
                                        <td>{{translate('draft.incomingDocId')}}</td>
                                        <td>:</td>
                                        <td>{{data.IncomingDocId }}</td>
                                    </tr>
                                    <tr v-show="data.Description">
                                        <td>{{translate('department.description')}}</td>
                                        <td>:</td>
                                        <td>{{data.Description}}</td>
                                    </tr>
                                    <tr v-show="data.Categories && data.Categories.length">
                                        <td>{{translate('draft.categories')}}</td>
                                        <td>:</td>
                                        <td>
                                            <label class="badge" v-for="c in data.Categories" :key="c.Id" style="margin-right:4px; background-color:#E1E1E1;">{{c.Name}}</label>
                                        </td>
                                    </tr>
                                    <tr v-if="data.CirculationProfileSchema">
                                        <td>{{translate('reportFilter.flow')}}</td>
                                        <td>:</td>
                                        <td>{{data.CirculationProfileSchema.Name}}</td>
                                    </tr>
                                    <tr v-show="data.TargetDate">
                                        <td>{{translate('draft.targetDate')}}</td>
                                        <td>:</td>
                                        <td>{{data.TargetDate | datetime}}</td>
                                    </tr>
                                    <tr v-if="data.Department || isAdmin">
                                        <td>{{translate('draft.department')}}</td>
                                        <td>:</td>
                                        <td>
                                            <template v-if="isAdmin && editDepartment">
                                                <select-input
                                                    :autocomplete="true"
                                                    :placeholder="translate('search')"
                                                    :items="departments"
                                                    :filter-function="(item, search) => new RegExp(search, 'i').test(item.Name)"
                                                    @change="departmentSelectChanged"
                                                    >
                                                        <span v-if="data.Department">
                                                            {{data.Department.Name}}
                                                        </span>
                                                        <span v-else>{{translate('draft.departmentIndependent')}}</span>
                                                        <template v-slot:item="{item}">
                                                            <div style="padding:2px 0;">
                                                                {{item.Name}}
                                                                <span v-if="!item.IsActive">({{translate('accountParams.passive')}})</span>
                                                            </div>
                                                        </template>
                                                </select-input>
                                            </template>
                                            <template v-else>
                                                <span v-if="data.Department">{{data.Department.Name}}&nbsp;</span>
                                                <i v-else class="text-muted" style="font-size: 0.9rem;">{{translate('draft.departmentIndependent')}}&nbsp;</i>
                                                
                                                <a v-if="isAdmin" href="javascript:void(0)" @click="editDepartment = true;" :title="translate('job.editDepartment')">
                                                    <icon-pencil-square/>
                                                </a>
                                            </template>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td>{{translate('job.currentStatus')}}</td>
                                        <td>:</td>
                                        <td><label class="badge" :class="'badge-' + jobStatusClass">{{jobStatusLabel}}</label></td>
                                    </tr>
                                    <tr v-if="data.DocumentType != 'General'">
                                        <td>{{translate('targetSystemImport.kind')}}</td>
                                        <td>:</td>
                                        <td>
                                            <job-document-type :documentType="data.DocumentType"/>
                                            <span v-show="data.Amount">
                                                —
                                                <span class="text-muted">{{data.Amount | money}} {{data.Currency}}</span>
                                            </span>
                                        </td>
                                    </tr>
                                    <tr v-if="data.DocumentType == 'Contract'">
                                        <td>{{translate('draft.contractAmount')}}</td>
                                        <td>:</td>
                                        <td>                     
                                            <div class="damga-vergisi-group">
                                                <input type="number" v-model.number="data.ContractAmount" class="damga-vergisi-input" style="width: 100px; flex: none;" :placeholder="translate('draft.amount')">                                
                                                <select v-model="data.ContractCurrency" class="damga-vergisi-input-select" style="max-width:70px;">
                                                    <option label="₺" value="TRY" >₺</option>
                                                    <option label="$" value="USD" >$</option>
                                                    <option label="€" value="EUR" >€</option>
                                                    <option label="£" value="GBP">£</option>
                                                    <option label="¥" value="JPY">¥</option>
                                                </select> 
                                                <button type="button" class="btn btn-info" @click="updateTaxPrice()" :title="translate('job.updateContractAmount')" style="margin-left:30px;">{{translate('update')}}</button>                  
                                            </div>
                                        </td>
                                    </tr>
                                    <tr v-if="data.Privacy != 'Normal'">
                                        <td>{{translate('draft.docPrivacy')}}</td>
                                        <td>:</td>
                                        <td v-html="$options.filters.privacy(data.Privacy)"></td>
                                    </tr>
                                    <tr>
                                        <td v-html="translate('job.jobsToSignApprove')"></td>
                                        <td>:</td>
                                        <td style="padding:0">
                                            <table class="table table-borderless table-hover table-sm">
                                                <tbody>
                                                    <tr v-for="d in data.Documents" :key="d.id" >
                                                        <td>
                                                            <file-download-link :isActive="userActions.CanDownload" :isOnlineView="onlineViewEnabled" :document="d" @download="downloadDocument" @preview="showFilePreview" :isDocumentFormat="isFilePattern"></file-download-link>
                                                        </td>
                                                        <td class="text-muted text-right" style="white-space:pre">
                                                            <span>{{d.UnsignedFile.Size | prettyBytes}}</span>
                                                         </td>                                                         
                                                        <td class="text-right signature-format-cell">
                                                            <span class="cursor-default" :class="d.SignatureFormat | signatureFormatBadge" :title="d.SignatureFormat | signatureFormat" >{{d.SignatureFormat | signatureFormatSymbol}}</span>
                                                        </td>
                                                    </tr>
                                                    <tr>
                                                        <td class="text-muted" style="white-space:pre">
                                                            <span>{{translate('job.totalDocAmount:' + data.Documents.length)}}</span>
                                                        </td>  
                                                        <td class="text-muted text-right" style="white-space:pre">
                                                            <span>{{data.Documents.map(d => d.UnsignedFile.Size).reduce((prev, curr) => prev + curr, 0) | prettyBytes}}</span>
                                                        </td>
                                                        <td>
                                                        </td>                                                         
                                                    </tr>
                                                    <tr v-if="data.Documents.length > 1">
                                                        <td class="text-muted" style="white-space:pre">
                                                            
                                                        </td>  
                                                        <td>
                                                        </td>
                                                        <td class="text-muted text-right" style="white-space:pre">
                                                            <button class="btn btn-sm btn-primary" @click="downloadAllFiles">{{translate('downloadAll')}}</button>
                                                        </td>
                                                    </tr>
                                                </tbody>
                                            </table>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td>{{translate('draftEyp.attachments')}}</td>
                                        <td>:</td>
                                        <td style="padding:0">
                                            <div v-if="!data.Attachments || !data.Attachments.length" class="text-muted" style="padding:4px; font-style:italic;">{{translate('incomingDocument.noAttachedFile')}}</div>
                                            <table v-else class="table table-borderless table-hover table-sm">
                                                <tbody>
                                                    <tr v-for="d in data.Attachments" :key="d.id">
                                                        <td>
                                                            <file-download-link :isActive="userActions.CanDownload" :isOnlineView="onlineViewEnabled" :document="d" @download="downloadAttachment" @preview="showFilePreview"></file-download-link>
                                                            <div style="font-size: 0.7rem; color:#333;" v-if="d.Date">
                                                                <span v-if="d.User">{{d.User.FullName}}</span>  - {{d.Date | datetime}}
                                                            </div>
                                                        </td>
                                                        <td class="text-muted text-right" style="white-space:pre">{{d.Size | prettyBytes}}</td>
                                                        <td style="vertical-align:top; width:1px;">
                                                            <button class="btn btn-sm btn-light" style="padding: 0px 2px;" :title="translate('job.removeFile')" @click="removeAttachment(d)" v-if="d.CanRemove">
                                                                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-trash" viewBox="0 0 16 16">
                                                                    <path d="M5.5 5.5A.5.5 0 0 1 6 6v6a.5.5 0 0 1-1 0V6a.5.5 0 0 1 .5-.5zm2.5 0a.5.5 0 0 1 .5.5v6a.5.5 0 0 1-1 0V6a.5.5 0 0 1 .5-.5zm3 .5a.5.5 0 0 0-1 0v6a.5.5 0 0 0 1 0V6z"/>
                                                                    <path fill-rule="evenodd" d="M14.5 3a1 1 0 0 1-1 1H13v9a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V4h-.5a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1H6a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1h3.5a1 1 0 0 1 1 1v1zM4.118 4 4 4.059V13a1 1 0 0 0 1 1h6a1 1 0 0 0 1-1V4.059L11.882 4H4.118zM2.5 3V2h11v1h-11z"/>
                                                                </svg>
                                                            </button>
                                                        </td>
                                                    </tr>
                                                </tbody>
                                            </table>
                                            
                                            <div class="float-right" v-if="data.CanAddAttachment && userActions.CanDownload">
                                                <file-upload
                                                    ref="uploadAttachments"
                                                    input-id="attachmentUpload"
                                                    v-model="attachments"
                                                    :post-action="
                                                        axios.defaults.baseURL +
                                                        '/jobattachment/addfile/' +
                                                        data.Id
                                                    "
                                                    :multiple="true"
                                                    :drop="false"
                                                    :thread="1"
                                                    @input="$refs.uploadAttachments.active = true"
                                                    chunk-enabled
                                                    :chunk="{
                                                    headers: {
                                                        token: axios.defaults.headers.common['token'],
                                                    },
                                                    action:
                                                        axios.defaults.baseURL +
                                                        '/jobattachment/addfilechunk/' +
                                                        data.Id,
                                                    minSize: 0,
                                                    maxActive: 3,
                                                    maxRetries: 3,

                                                    // Example in the case your backend also needs the user id to operate
                                                    startBody: {
                                                        //user_id: user.id
                                                    },
                                                    }"
                                                >
                                                    <!-- <div class="row select-file" id="attachments">
                                                        <div class="col">
                                                            İşe dahil edilecek ek dosyaları seçmek için buraya tıklayınız...
                                                        </div>
                                                    </div> -->
                                                    <button type="button" class="btn btn-sm btn-outline-secondary">
                                                        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-plus" viewBox="0 0 16 16">
                                                            <path d="M8 4a.5.5 0 0 1 .5.5v3h3a.5.5 0 0 1 0 1h-3v3a.5.5 0 0 1-1 0v-3h-3a.5.5 0 0 1 0-1h3v-3A.5.5 0 0 1 8 4z"/>
                                                        </svg>
                                                        {{translate('draft.addFile')}}
                                                    </button>
                                                </file-upload>
                                            </div>
                                            <div style="clear:both"></div>
                                            <ul>
                                                <!-- <li>{{file.name}} {{file.active}} {{file.success}} {{file.progress}} {{file.error}}</li> -->
                                                <li
                                                v-for="file in attachments"
                                                :key="file.id"
                                                v-show="!file.success"
                                                >
                                                <div>{{ file.name }}</div>
                                                <div class="progress" v-if="file.active">
                                                    <div
                                                    class="progress-bar progress-bar-striped progress-bar-animated text-left"
                                                    role="progressbar"
                                                    aria-valuenow="75"
                                                    aria-valuemin="0"
                                                    aria-valuemax="100"
                                                    :style="{ width: file.progress + '%' }"
                                                    >
                                                    &nbsp;%{{ parseInt(file.progress, 10) }}
                                                    </div>
                                                </div>
                                                <div class="text-danger" style="font-size:0.8rem" v-if="file.error">
                                                    <div v-for="ms in file.response.ModelState" :key="ms">
                                                        <div v-for="err in ms" :key="err">{{err}}</div>
                                                    </div>
                                                </div>
                                                </li>
                                            </ul>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>

                        </div>
                        <div class="rbcontent" style="background-color: #ffc1071f!important; border-top: 1px solid rgba(0, 0, 0, 0.03); border-bottom: 1px solid rgba(0, 0, 0, 0.03);">
                            <div class="form-group" v-show="userActions.CanApprove || userActions.CanSign || userActions.CanDecline || userActions.CanCancel || userActions.CanUndoCancel">
                                <label>{{translate('department.description')}}:</label>
                                <!-- <textarea class="form-control" @keydown.enter.prevent="false" maxlength="2000" placeholder="İşleminize ilişkin not veya red gerekçeniz..." v-model.trim="description" rows="3"></textarea> -->
                                <text-area-input className="form-control" :allowExceed="false" :maxlength="500" @keydown.enter.prevent="false" :placeholder="translate('job.denyDescriptionText')" v-model.trim="description" rows="3" />
                            </div>
                            <div class="form-group" v-if="userActions.CanApprove">
                                <label>
                                    <input type="checkbox" v-model="approveCheck" required>
                                    {{translate('job.docApproveText')}}
                                </label>
                            </div>
                            <div class="row">
                                <div class="col job-actions col-left">
                                    <button type="button" class="btn btn-danger" @click="decline" v-if="userActions.CanDecline">{{translate('job.decline')}}</button>
                                    <button type="button" class="btn btn-outline-danger" @click="cancel" v-if="userActions.CanCancel" :title="translate('job.cancelTitle')">{{translate('job.cancel')}}</button>
                                    <button type="button" class="btn btn-outline-secondary" @click="undoCancel" v-if="userActions.CanUndoCancel" :title="translate('job.undoCancelTitle')">{{translate('job.undoCancel')}}</button>
                                    <button type="button" class="btn btn-outline-secondary" @click="copy" v-if="userActions.CanCreateDraftCopy" :title="translate('job.createDraftCopyTitle')">{{translate('job.createDraftCopy')}}</button>
                                </div>
                                <div class="col text-right job-actions">
                                    <button type="button" class="btn btn-success" @click="approve" v-if="userActions.CanApprove" :title="translate('job.approveTitle')">{{translate('job.approve')}}</button>
                                    <button type="button" class="btn btn-primary" @click="showSignaturePanel()" v-if="userActions.CanSign" :title="translate('job.eSignTitle')">{{translate('eSign')}}</button>
                                    <button v-show="!hideMobileSign" type="button" class="btn btn-info" @click="showMobilePanel()" v-if="userActions.CanSign" :title="translate('job.mobileSignTitle')">{{translate('mobileSignatureTexts.mobileSign')}}</button>
                                </div>
                            </div>
                        </div>
                        <div class="rbcontent">
                            <div>
                                <h5>{{translate('circulationProfileSchema.targetSystems')}}</h5>
                                <table class="table table-borderless table-striped table-hover">
                                    <tbody>
                                        <tr v-for="f in data.Finalizers" :key="f.Id">
                                            <td style="width:24px;">
                                                <finalizer-state-icon :state="f.State" :show-label="false" />
                                            </td>
                                            <td>{{f.TargetSystem.Name}} (<small class="text-muted">{{f.TargetSystem.Kind | targetSystemKind}}</small>)</td>
                                            <td class="text-right" style="padding:8px;">
                                                <div class="custom-button-container">
                                                    <button type="button" class="btn btn-outline-primary btn-sm" @click="evidenceFinalizer = f" v-show="f.State == 'Success' && f.TargetSystem.Kind == 'Rem'" style="margin-left:8px;">{{translate('evidences.evidences')}}</button>
                                                    <!-- <button type="button" class="btn btn-success btn-sm" @click="sendRem(f)" v-show="userActions.CanSendRem && (f.State == 'Waiting' || f.State == 'Fail') && f.TargetSystem.Kind == 'Rem'">KEP Gönder</button> -->
                                                    <button type="button" class="btn btn-outline-secondary btn-sm" @click="finalizerDetail = f" style="margin-left:8px;">{{translate('job.details')}}</button>
                                                    <div style="max-width: 100px;">
                                                        <VDropdown placement='top' theme="dropdown">            
                                                            <!-- This will be the popover target (for the events and position) -->
                                                            <button class="btn btn-success btn-sm" v-show="userActions.CanSendRem && (f.State == 'Waiting' || f.State == 'Fail') && f.TargetSystem.Kind == 'Rem'">{{translate('job.sendKep')}}</button>
                                                            <!-- This will be the content of the popover -->
                                                            <template #popper>
                                                                <button class="btn btn-info btn-sm" style="margin: 10px" @click="sendRem(f)">{{translate('eSign')}}</button>
                                                                <button class="btn btn-info btn-sm" style="margin: 10px" @click="sendWithMobileSignature(f)">{{translate('mobileSignatureTexts.mobileSign')}}</button>
                                                            </template>
                                                        </VDropdown>
                                                    </div>
                                                </div>
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                    <div class="xd" style="background-color:rgba(0,0,0,.02); border-left: 1px solid rgba(0,0,0,.03);">
                        <div class="rbcontent" style="padding-left:15px;">
                            <h5 class="onlyMobileVisible">{{$t('circulationProfileSchema.steps')}}</h5>
                            <table class="table table-borderless table-hover">
                                <tbody>
                                    <tr v-for="s in data.FlowSummary" :key="s.Date" style="border-bottom:1px solid rgba(0,0,0,.04)">
                                        <td style="width:1px; vertical-align:middle; text-align:center; padding-left:12px; opacity:0.7" >
                                            <icon-arrow-right-circle-fill v-if="s.Tense == 'Past' && s.Type != 'Decline' && s.Type != 'Cancel'" :title="translate('messages.success')" width="2em" height="2em" viewBox="0 0 48 48" :class="[s.Type == 'Decline' ? 'text-danger' : 'text-success', s.Type == 'Cancel' ? 'text-warning' : 'text-success' ]" />
                                            <svg xmlns="http://www.w3.org/2000/svg" v-if="s.Tense == 'Past' && s.Type== 'Decline'" :title="translate('errors.processCancelled')" height="2em" width="2em" class="text-danger" fill="currentColor" viewBox="0 0 48 48">
                                                <path d="m16.6 33 7.4-7.4 7.4 7.4 1.6-1.6-7.4-7.4 7.4-7.4-1.6-1.6-7.4 7.4-7.4-7.4-1.6 1.6 7.4 7.4-7.4 7.4ZM24 43q-3.9 0-7.375-1.5t-6.05-4.075Q8 34.85 6.5 31.375 5 27.9 5 24q0-3.95 1.5-7.425Q8 13.1 10.575 10.55 13.15 8 16.625 6.5 20.1 5 24 5q3.95 0 7.425 1.5Q34.9 8 37.45 10.55 40 13.1 41.5 16.575 43 20.05 43 24q0 3.9-1.5 7.375t-4.05 6.05Q34.9 40 31.425 41.5 27.95 43 24 43Z"/>
                                            </svg>
                                            <svg xmlns="http://www.w3.org/2000/svg" v-if="s.Tense == 'Past' && s.Type== 'Cancel'" :title="translate('errors.processCancelled')" height="1.7em" width="1.7em" class="text-warning" fill="currentColor" viewBox="0 0 16 16">
                                                <path d="M16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0zM4.5 7.5a.5.5 0 0 0 0 1h7a.5.5 0 0 0 0-1h-7z"/>
                                            </svg>
                                            <icon-arrow-right-circle v-if="s.Tense == 'Present'" :title="translate('errors.processWaiting')" width="1.7em" height="1.7em" viewBox="0 0 16 16"  class="text-primary"  />

                                            <!--<svg v-if="s.Tense == 'Future'" title="İşlem henüz gerçekleşmedi" width="1.6em" height="1.6em" viewBox="0 0 16 16" class="text-muted bi bi-hourglass-split" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
                                                <path fill-rule="evenodd" d="M6 .5a.5.5 0 0 1 .5-.5h3a.5.5 0 0 1 0 1H9v1.07A7.001 7.001 0 0 1 8 16 7 7 0 0 1 7 2.07V1h-.5A.5.5 0 0 1 6 .5zM8 3a6 6 0 1 0 .001 12A6 6 0 0 0 8 3zm0 2.1a.5.5 0 0 1 .5.5V9a.5.5 0 0 1-.5.5H4.5a.5.5 0 0 1 0-1h3V5.6a.5.5 0 0 1 .5-.5z"/>
                                            </svg>-->

                                            <svg xmlns="http://www.w3.org/2000/svg" v-if="s.Tense == 'Future'" :title="translate('errors.processDidntHappen')" width="1.6em" height="1.6em" viewBox="0 0 48 48" fill="currentColor">
                                                <path fill-rule="evenodd" d="m31.5 33.25 1.7-1.7-7.95-8V13.5H23v10.95ZM24 43q-3.9 0-7.375-1.5t-6.05-4.075Q8 34.85 6.5 31.375 5 27.9 5 24t1.5-7.375q1.5-3.475 4.075-6.05Q13.15 8 16.625 6.5 20.1 5 24 5t7.375 1.5q3.475 1.5 6.05 4.075Q40 13.15 41.5 16.625 43 20.1 43 24t-1.5 7.375q-1.5 3.475-4.075 6.05Q34.85 40 31.375 41.5 27.9 43 24 43Zm0-19Zm0 16.75q6.9 0 11.825-4.925Q40.75 30.9 40.75 24q0-6.9-4.925-11.825Q30.9 7.25 24 7.25q-6.9 0-11.825 4.925Q7.25 17.1 7.25 24q0 6.9 4.925 11.825Q17.1 40.75 24 40.75Z"/>
                                            </svg>

                                            <!--<svg v-if="s.Tense == 'Canceled'" title="İşlem iptal edildi" width="1.6em" height="1.6em" xmlns="http://www.w3.org/2000/svg" fill="currentColor" class="text-warning bi bi-dash-circle" viewBox="0 0 16 16">
                                                <path d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14zm0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16z"/>
                                                <path d="M4 8a.5.5 0 0 1 .5-.5h7a.5.5 0 0 1 0 1h-7A.5.5 0 0 1 4 8z"/>
                                            </svg>-->
                                            <svg xmlns="http://www.w3.org/2000/svg" v-if="s.Tense == 'Canceled'" :title="translate('errors.processWaiting')" height="2em" width="2em" fill="currentColor" viewBox="0 0 48 48">
                                                <path d="m16.6 33 7.4-7.4 7.4 7.4 1.6-1.6-7.4-7.4 7.4-7.4-1.6-1.6-7.4 7.4-7.4-7.4-1.6 1.6 7.4 7.4-7.4 7.4ZM24 43q-3.9 0-7.375-1.5t-6.05-4.075Q8 34.85 6.5 31.375 5 27.9 5 24q0-3.95 1.5-7.425Q8 13.1 10.575 10.55 13.15 8 16.625 6.5 20.1 5 24 5q3.95 0 7.425 1.5Q34.9 8 37.45 10.55 40 13.1 41.5 16.575 43 20.05 43 24q0 3.9-1.5 7.375t-4.05 6.05Q34.9 40 31.425 41.5 27.95 43 24 43Z"/>
                                            </svg>

                                        </td>
                                        <td>
                                            <button @click="resendNotification" :disabled="resendNotificationSuccess" :title="translate('messages.resendNotification')" v-if="s.Tense == 'Present' && s.Relateds && s.Relateds.length > 0 && data.State == 'Circulating'" v-show="userActions.CanResendReminder" class="btn btn-sm btn-outline-secondary float-right" type="button">
                                                <icon-bell/>
                                                {{translate('job.resendNotification')}}
                                            </button>
                                            <div class="">
                                                <div v-if="s.TargetSystem">
                                                    <span class="text-muted">{{translate('remPreview.receiver')}}:</span> {{s.TargetSystem.Name}}
                                                </div>
                                                <div>
                                                    <span v-for="(u) in s.Relateds" :key="u.Id" >
                                                        <!-- <span v-if="index > 0">,</span> -->
                                                        <img v-auth-image="u.ProfilePictureUrl" class="flow-picture" />
                                                        <b>{{u.Name}}</b>
                                                        <span v-if="u.Type == 'External'">
                                                                ({{translate('approvalAuthorityInfo.externalUser')}}) 
                                                        </span> <br>
                                                    </span>
                                                   
                                                </div>
                                                <div style="font-size: 0.9rem; padding-top: 3px;" >
                                                    <div v-if="s.Tense == 'Canceled' ">
                                                        <span style="text-decoration: line-through" >{{s.Description}}</span>
                                                    </div>
                                                    <div v-else>        
                                                        <icon-dash-circle v-if="s.Type == 'Cancel'" class="text-warning" />
                                                        <icon-x-circle v-if="s.Type == 'Decline'" class="text-danger" />
                                                        <icon-circle v-if="s.Type == 'UndoCancel'" class="text-primary" />                                           
                                                        {{s.Description}}
                                                    </div>
                                                        <button v-if="s.Type == 'ApproveOTP'" type="button" class="btn btn-info btn-sm" @click="downloadLog(s.StepIndex)">{{translate('job.downloadLog')}}</button>
                                                </div>
                                                <small class="text-muted" v-show="s.Note">
                                                    {{s.Note}}
                                                </small>
                                            </div>
                                            <div class="float-right text-muted" style="margin-top: -20px; position: relative;"><small>{{s.Date | datetime}}</small></div>

                                            
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>

                    <!-- İMZA MODAL -->
                    <signature-modal
                        v-if="isSignaturePanelVisible"
                        :signingItems="signingItems"
                        :identityNumber="identityNumber"
                        :processingMessage="processingMessage"
                        @close="isSignaturePanelVisible=false"
                        @completed="signingCompletedFunction"
                         ></signature-modal>
                    <!-- <div v-if="isSignaturePanelVisible" class="modal fade show" style="display: block" tabindex="-1" role="dialog">
                        <form @submit.prevent="$refs.imzalayici.sign()">
                            <div class="modal-dialog modal-lg modal-dialog-centered">
                                <div class="modal-content">
                                <div class="modal-header">
                                    <h5 class="modal-title">İmzala</h5>
                                    <button type="button" class="close" data-dismiss="modal" :disabled="imzalayiciLoading" aria-label="Kapat" @click="isSignaturePanelVisible=false">
                                        <span aria-hidden="true">&times;</span>
                                    </button>
                                </div>
                                <div class="modal-body">
                                    <imzalayici ref="imzalayici" style="height:390px;" :items="signingItems" :identityNumber="identityNumber" :processingMessage="processingMessage" @onloading="imzalayiciOnLoading" @completed="signingCompletedFunction"></imzalayici>
                                </div>
                                <div class="modal-footer">
                                    <button type="button" class="btn btn-outline-secondary" :disabled="imzalayiciLoading" @click="isSignaturePanelVisible = false">Kapat</button>
                                    <button type="button" class="btn btn-danger" style="width:100px;" v-show="imzalayiciLoading" @click="$refs.imzalayici.cancel()" data-dismiss="modal">İptal</button>
                                    <button type="submit" class="btn btn-success" style="width:100px;" v-show="!imzalayiciLoading">İmzala</button>
                                </div>
                                </div>
                            </div>
                        </form>
                    </div> -->
                    <!-- İMZA MODAL SONU -->
                    <!-- MOBİL İMZA MODAL -->
                    <div v-if="isMobilePanelVisible" class="modal fade show" style="display: block;" tabindex="-1" role="dialog">
                        <div class="modal-dialog modal-lg modal-dialog">
                            <div class="modal-content">
                            <div class="modal-header">
                                <h5 class="modal-title">{{translate('job.signWithMobileSing')}}</h5>
                                <button type="button" class="close" data-dismiss="modal" :disabled="imzalayiciLoading" :aria-label="translate('close')" @click="isMobilePanelVisible=false">
                                    <span aria-hidden="true">&times;</span>
                                </button>
                            </div>
                            <div class="modal-body">
                                <mobil-imzala ref="mobileSign" :items="mobileItems" @onloading="imzalayiciOnLoading" @completed="signingCompletedFunction" :processingMessage="processingMessage"></mobil-imzala>
                            </div>
                            <div class="modal-footer footer-button-container-1">
                                <button type="button" class="btn btn-outline-secondary" @click="closeMobileSignModal()">{{translate('close')}}</button>
                                <!-- <button type="button" class="btn btn-danger" style="width:100px;" v-show="imzalayiciLoading" @click="$refs.mobileSign.cancel()" data-dismiss="modal">İptal</button> -->

                                <button type="submit" class="btn btn-success" style="width:140px;" :disabled="imzalayiciLoading" @click="$refs.mobileSign.sign()">{{translate('mobileSignatureTexts.mobileSign')}}</button>

                            </div>
                            </div>
                        </div>
                    </div>
                    <!-- MOBİL İMZA MODAL SONU -->
                    <!-- OTP MODAL BAŞLANGICI -->
                    <div
                        v-if="isOTPPanelVisible"
                        class="modal fade show"
                        style="display: block"
                        tabindex="-1"
                        role="dialog"
                    >
                        <div class="modal-dialog modal-dialog-centered">
                        <div class="modal-content">
                            <div class="modal-header">
                            <h5 class="modal-title">{{translate('job.smsIdentityVerification')}}</h5>
                            <button
                                type="button"
                                class="close"
                                data-dismiss="modal"
                                :disabled="loading"
                                :aria-label="translate('close')"
                                @click="isOTPPanelVisible = false"
                            >
                                <span aria-hidden="true">&times;</span>
                            </button>
                            </div>
                            <div class="modal-body">
                            <div v-if="this.validationResult">
                                <form @submit.prevent="validate">
                                <fieldset :disabled="loading">
                                    <p v-if="this.validationResult.Mobile">
                                    <span v-html="translate('login.sentToMobileNumberWithField:'+this.validationResult.Mobile)"></span>
                                    <!-- <b>{{ this.validationResult.Mobile }}</b> numaralı telefonunuza doğrulama kodu SMS
                                    olarak gönderilmiştir ve kısa süre içerisinde ulaşacaktır. -->
                                    </p>
                                    <p v-else>
                                        {{translate('login.sentToMobileNumberWithoutField')}}
                                    </p>

                                    <div class="form-group">
                                    <label>{{translate('login.enterMobileValidationCode')}}</label>
                                    <input
                                        v-model="approveForm.OTP"
                                        type="text"
                                        class="form-control text-center"
                                        aria-describedby="validationCodeHelp"
                                        required
                                    />
                                    </div>
                                    <div v-if="errorMessage" class="text-danger">
                                        {{translate('login.error')}} {{ errorMessage }}
                                    </div>
                                    <div v-show="processingMessage" class="text-center text-primary" style="line-height:32px;">
                                        <img src="../assets/loading_blue.gif" />
                                        {{processingMessage}}
                                    </div>
                                </fieldset>
                                </form>
                            </div>
                            <div v-else>
                                <div v-show="processingMessage" class="text-center text-primary" style="line-height:32px;">
                                    <img src="../assets/loading_blue.gif" />                    
                                    {{translate('loading')}}
                                </div>
                            </div>        
                            </div>
                            <div class="modal-footer footer-button-container-1">
                            <button
                                type="button"
                                class="btn btn-outline-secondary"
                                @click="isOTPPanelVisible = false"
                            >
                            {{translate('close')}}
                            </button>
                            <button
                                type="submit"
                                class="btn btn-success"
                                style="width: 100px"
                                :disabled="loading"
                                @click="validate"
                            >
                            {{translate('job.validate')}}
                            </button>
                            </div>
                        </div>
                        </div>
                    </div>
                    <!-- OTP MODAL SONU  -->
                    <finalizer v-if="finalizerDetail" :finalizer="finalizerDetail" :canReSend="userActions.CanReSendTargetSystem" @onclose="finalizerDetail = null" @resend="reSendTargetSystem"></finalizer>
                    <evidences v-if="evidenceFinalizer && !isSignaturePanelVisible" :finalizer="evidenceFinalizer" @onclose="evidenceFinalizer = null" @refresh="refreshEvidences"></evidences>
                    <file-preview v-if="fileDetail" :file="fileDetail" :isOnlineView="onlineViewEnabled" :viewer="viewerType" @close="fileDetail=null;"></file-preview>
                    <external-user-summary v-if="externalUserDetail" v-bind="externalUserDetail"/>
                </div>
            </div>
        </div>
        <div v-else class="text-muted text-center" style="padding:100px 0;">
            {{translate('loading')}}
        </div>
    </fieldset>
</template>
<script>
import axios from 'axios'
import formMixin from '../formMixin.js';
//import imzalayici from '../components/Imzalayici.vue'
import mobilImzala from '../components/MobileSign.vue'
import finalizer from '../components/JobFinalizer.vue'
import finalizerStateIcon from '../components/FinalizerStateIcon.vue';
import evidences from '../components/Evidences.vue';
import jobDocumentType from '../components/JobDocumentType.vue';
import filePreview from '../components/FilePreview.vue';
import fileDownloadLink from '../components/FileDownloadLink.vue'
import selectInput from "../components/SelectInput.vue";
import fileUpload from "vue-upload-component"; // https://lian-yue.github.io/vue-upload-component/#/en/documents#getting-started-npm
import externalUserSummary from '../components/ExternalUserSummary.vue'
import signatureModal from '../components/SignatureModal.vue'
import TextAreaInput from '@/components/TextAreaInput.vue';
// import pdfViewer from '../components/PDFJSViewer.vue';
import Vue from 'vue';
import 'floating-vue/dist/style.css'

import {
  // Directives
  VTooltip,
  VClosePopper,
  // Components
  Dropdown,
  Tooltip,
  Menu
} from 'floating-vue'

Vue.directive('tooltip', VTooltip)
Vue.directive('close-popper', VClosePopper)

Vue.component('VDropdown', Dropdown)
Vue.component('VTooltip', Tooltip)
Vue.component('VMenu', Menu)

import iconBell from '../components/Icons/bell.svg'
import iconDashCircle from '../components/Icons/dash-circle.svg'
import iconXCircle from '../components/Icons/x-circle.svg'
import iconCircle from '../components/Icons/circle.svg'
import iconArrowRightCircle from '../components/Icons/arrow-right-circle.svg'
import iconArrowRightCircleFill from '../components/Icons/arrow-right-circle-fill-2.svg'
import iconPencilSquare from '@/components/Icons/pencil-square.svg'


export default {
    mixins: [formMixin],
    components: {
    //imzalayici,
    // pdfViewer,
    mobilImzala,
    finalizer,
    evidences,
    finalizerStateIcon,
    jobDocumentType,
    filePreview,
    fileDownloadLink,
    selectInput,
    fileUpload,
    externalUserSummary,
    signatureModal,
    TextAreaInput,
    iconBell,
    iconDashCircle,
    iconXCircle,
    iconCircle,
    iconArrowRightCircle,
    iconArrowRightCircleFill,
    iconPencilSquare,
},
    created(){
        if(this.isAdmin) {
            this.getDepartments()
            .then(x => {
                this.departments = [{Id:'', Name: 'Departman bağımsız', IsActive: true}].concat(x.Result);
                console.log('Departments: ', this.departments);
            }).catch(x => {
                console.warn("Departman listesi yüklenemedi:", x);
            });
        }
        this.getOnlineViewPermission()
        .then(x => {
            this.onlineViewEnabled = x;
        }).catch(x => {
            console.warn("getOnlineViewPermission alınamadı:", x);
            this.onlineViewEnabled = true;
        });
        this.getData(this.$route.params.id);
    },
    data(){
        return {
            //job: {TrackingNo:{}},
            // pdfURL: null,
            isViewable : false,
            isDownloadable : false,
            description: null,
            approveCheck: false,
            isSignaturePanelVisible:false,  // Token ile imzalama paneli aktif mi
            isMobilePanelVisible: false,    // Mobil imza ile imzalama paneli aktif mi
            editDepartment: false,          // Admin için departman inputu aktif mi?
            signError : null,
            signingItems: [],
            loading: false,
            data: null,
            userActions: {},
            externalUserDetail: null,   // Seçili dış kullanıcı bilgileri
            resendNotificationSuccess: false, // 'Yeniden Bildirim Gönder' işlemi başarılı mı?
            imzalayiciLoading: false,   // İmzalayıcı 'loading' pozisyonunda mı
            mobileSignLoading: false,   // Mobil imza 'loading' pozisyonunda mı
            processingMessage: null,    // İmzalanan dosyalar sunucuya gönderiliyorken gösterilecek mesaj
            finalizerDetail: null,      // Detayları popup içinde görüntülenecek hedef sistem. Boş olursa popup görüntülenmez
            evidenceFinalizer: null,    // KEP dedilleri listelenecek hedef sistem
            sendRemFinalizer: null,     // KEP iletisi gönderilmek üzere imzalanan hedef sistem
            fileDetail: null,           // Önizlemesi görüntülenecek dosya
            departments: [],             // Adin kullanıcının departman değiştirebilmesi için gerekli olan departman listesi.
            attachments: [],
            isOTPPanelVisible: false,
            validationResult: {},
            approveForm: {},
            onlineViewEnabled: true,
            signingCompletedFunction: function(){
                alert(this.translate('warnings.signingCompletedUndefined'));
                console.warn('signingCompletedFunction fonksiyonu tanımsız!');
            },
            sameUser: Boolean
        };
    },
    watch: {
        attachments: function (oldFiles, newFiles) {
            console.log('Newfiles: ', newFiles);
            newFiles
                .filter((x) => x && x.response.attachment)
                .forEach((element) => {
                if (
                    this.data.Attachments.filter(
                    (d) => d.Id == element.response.attachment.Id
                    ).length == 0
                ) {
                    this.data.Attachments.push(element.response.attachment);
                    console.log("Attachments", this.data.Attachments);
                }

                this.$refs.uploadAttachments.remove(element);
                });
        },
    },
    methods: {
        downloadAllFiles(){
            var downloadUrl = '/job/CreateAllDocumentUrl';
            return axios.get(downloadUrl, {params: {jobId : this.data.Id}})
            .then((response) => {
                window.open(response.data, '_blank')
            }).catch( () => {
                alert(this.translate('errors.errorOccuredWhenDownloading'))
            })
        },
        updateTaxPrice(){
            this.loading = true;
            axios.post("/job/updateTaxPrice" , { 
                Id : this.data.Id, 
                newContractAmount : this.data.ContractAmount,
                newContractCurrency : this.data.ContractCurrency 
            })
            .then(() => {
                   alert(this.translate('messages.amountUpdateSuccessful'))
                    this.loading = false;
                })
                .catch(() => {
                    alert(this.translate('errors.amountUpdateFail'))
                    this.loading = false;
                })
        },

        closeMobileSignModal(){
            this.isMobilePanelVisible = false;
            this.imzalayiciLoading = false;
        },
        departmentSelectChanged(value){
            if(confirm(this.translate('warnings.departmentWillChange'))){
                this.loading = true;
                axios.post("job/changedepartment", {
                    JobId : this.data.Id,
                    DepartmentId : value?.Id
                }).then(x => {
                    this.data.Department = x.data;
                    this.loading = false;
                })
                .catch(x => {
                    window.processErrorResponse(x, this);
                    this.loading = false;
                })
            }
        },
        removeAttachment(document) {
            if(confirm(this.translate('warnings.docWillBeDeleted:'+ document.FileName))) {
                this.loading = true;
                axios.post('jobattachment/remove', {
                    JobId : this.data.Id,
                    AttachmentId : document.Id
                }).then(x => {
                    this.data.Attachments = x.data;
                    this.loading = false;
                })
                .catch(x => {
                    window.processErrorResponse(x, this);
                    this.loading = false;
                })
            }
        },
        showFilePreview(document, type, isFormatted) {
            console.log(document);

            this.fileDetail = document;
            this.viewerType = type;
            this.fileDetail.EntityId = this.data.Id;
            if(isFormatted)
                this.fileDetail.IsFormatted = true;
            else
                this.fileDetail.IsFormatted = false;
            console.log(this.fileDetail)
        },
        reSendTargetSystem(finalizer){
            console.log('Resend:', finalizer);
            this.loading = true;

            axios.post('/job/ReSendTargetSystem', {
                JobId: this.data.Id,
                FinalizerId : finalizer.Id,
                Description : this.translate('warnings.willSendAgain')
            })
            .then(x => {
                if(x.data.Success) {
                    this.data = x.data.Data;
                    this.finalizerDetail = this.data.Finalizers.filter(x => x.Id == this.finalizerDetail.Id)[0];
                } else {
                    alert(this.translate('errors.cannotResendToTarget') + x.data.ErrorMessages);
                }
            })
            .catch(x => {
                alert(this.translate('errors.cannotResendToTarget'));
                console.warn('Yeniden gönderim sağlanamadı: ', x);
            })
            .then(() => {
                this.loading = false;
            })
        },
        refreshEvidences(finalizer){
            this.loading = true;
            axios.post(`/rem/refreshevidences/${this.data.Id}?finalizerId=${finalizer.Id}`)
            .then(x => {
                if(x.data.Success) {
                    this.data = x.data.Data;
                    this.evidenceFinalizer = this.data.Finalizers.filter(x => x.Id == this.evidenceFinalizer.Id)[0];
                    this.isSignaturePanelVisible = false;
                } else {
                    alert(this.translate('errors.evidenceRefreshFailed') +x.data.ErrorMessages);
                }
            })
            .catch(x => {
                console.log('user: ', this.$root.$data.login);
                if(x.response.data.ModelState.RemSessionTimeoutException) {
                    alert(x.response.data.ModelState.RemSessionTimeoutException);

                    if(this.hasAuth('Rem') && this.hasModule('REM')) {
                        var scp = this;
                        this.signingCompletedFunction = function(){
                            scp.refreshEvidences(finalizer);
                            scp.processingMessage = this.translate('processingMessages.evidencesRefreshing');
                        };

                        this.signingItems = [
                            {
                                DocumentId: "agreement",
                                SignatureFormat: "CAdES",
                                FileName : "KEP oturum taahhütnamesi.txt",
                                State: '',
                                GetUrl: `/Rem/login?jobId=${this.data.Id}&documentId=agreement&finalizerId=${finalizer.Id}`,
                                PostUrl: '/Rem/login',
                                PostParams: { JobId: this.data.Id, DocumentId: 'agreement', FinalizerId : finalizer.Id }
                            }
                        ];

                        this.isSignaturePanelVisible = true;
                    }
                } else {
                    this.processingMessage = null;
                    window.processErrorResponse(x, this);
                }
            })
            .then(() => {
                this.processingMessage = null;
                this.loading = false;
            })
        },
        resendNotification(){
            if(confirm(this.translate('warnings.resendNotification'))) {
                this.loading = true;
                axios.post(`/job/resendnotification/${this.data.Id}`)
                .then(x => {
                    if(x.data.Success) {
                        alert(this.translate('messages.resendNotificationSent'));
                        this.resendNotificationSuccess = true;
                    } else {
                        alert(this.translate('errors.notificationSendFailed') + '\r\n' + x.data.ErrorMessages);
                    }
                    this.loading = false;
                })
                .catch(x => {
                    window.processErrorResponse(x, this);
                })
            }
        },
        sendRem(finalizer){
            // KEP gönderimi için imza panelini açar
            if(!this.$root.$data.login.User.IdentityNumber) {
                if(confirm(this.translate('warnings.identityMissing'))) {
                    this.$router.push({ name:'UserIdentity', params: { id: this.$root.$data.login.User.Id } });
                }
                return;
            }
            this.sendRemFinalizer = finalizer;
            console.log('SendRemFinalizer: ', finalizer);
            this.signingCompletedFunction = this.remSigningCompleted;

            this.signingItems = [];

            if(finalizer.RemOperation.ESignLogin) {
                this.signingItems.push({
                    DocumentId: "agreement",
                    SignatureFormat: "CAdES",
                    FileName : "KEP oturum taahhütnamesi.txt",
                    State: '',
                    GetUrl: `/Rem/login?jobId=${this.data.Id}&documentId=agreement&finalizerId=${finalizer.Id}`,
                    PostUrl: '/Rem/login',
                    PostParams: { JobId: this.data.Id, DocumentId: 'agreement', FinalizerId : finalizer.Id }
                });
            }
                
            this.signingItems.push(
                {
                    DocumentId: "mime",
                    SignatureFormat: "CAdES",
                    FileName : "KEP iletisi.eml",
                    State: '',
                    GetUrl: `/Rem/ContentForSign?jobId=${this.data.Id}&documentId=mime&finalizerId=${finalizer.Id}`,
                    PostUrl: '/Rem/ContentForSign',
                    PostParams: { JobId: this.data.Id, DocumentId: 'mime', FinalizerId : finalizer.Id }
                });

            this.isSignaturePanelVisible = true;
        },
        sendWithMobileSignature(finalizer){
            // Mobil İmza ile KEP gönderimi için imza panelini açar
            if(!this.$root.$data.login.User.IdentityNumber) {
                if(confirm(this.translate('warnings.identityMissing'))) {
                    this.$router.push({ name:'UserIdentity', params: { id: this.$root.$data.login.User.Id } });
                }
                return;
            }

            this.sendRemFinalizer = finalizer;
            console.log('SendRemFinalizer: ', finalizer);
            this.signingCompletedFunction = this.remSigningCompleted;

            this.mobileItems = [];

            if(finalizer.RemOperation.ESignLogin) {
                this.mobileItems.push({
                    DocumentId: "agreement",
                    SignatureFormat: "CAdES",
                    FileName : "KEP oturum taahhütnamesi.txt",
                    State: '',
                    FingerprintUrl: `/Rem/CalculateFingerprintForLogin/?jobId=${this.data.Id}&documentId=agreement&finalizerId=${finalizer.Id}`,
                    PostUrl: `/Rem/SignMobileForLogin/?jobId=${this.data.Id}&documentId=agreement&finalizerId=${finalizer.Id}&fingerPrintTempFileId={0}`,
                    PostParams: { JobId: this.data.Id, DocumentId: 'agreement', FinalizerId : finalizer.Id }
                });
            }
            
            this.mobileItems.push({
                    DocumentId: "mime",
                    SignatureFormat: "CAdES",
                    FileName : "KEP iletisi.eml",
                    State: '',
                    FingerprintUrl: `/Rem/CalculateFingerprint/?jobId=${this.data.Id}&documentId=mime&finalizerId=${finalizer.Id}`,
                    PostUrl: `/Rem/SignMobile/?jobId=${this.data.Id}&documentId=mime&finalizerId=${finalizer.Id}&fingerPrintTempFileId={0}`,
                    PostParams: { JobId: this.data.Id, DocumentId: 'mime', FinalizerId : finalizer.Id }
                });
                
            this.isMobilePanelVisible = true;           
        },
        imzalayiciOnLoading(e){
             console.log('onLoading: ', e);
             this.imzalayiciLoading = e;
        },
        remSigningCompleted(){
            // Dosyaların imzalanması tamamlandığında sunucu tarafında kabul işlemini başlatır.
            // Bu metodu imzalayıcı componenti @complete eventinde tetikler
            this.loading = true;

            this.processingMessage = this.translate('processingMessages.kepSending') ;
            this.$forceUpdate();

            axios.get(`/rem/sendrem/?jobId=${this.data.Id}&finalizerId=${this.sendRemFinalizer.Id}`).then(x => {
                if(x.data.Success) {
                    this.$router.push({ name:'RemList' });
                } else {
                    alert(x.data.ErrorMessages);
                    this.$refs.imzalayici.loading = false;
                }
            }).catch(x => {
                console.warn('KEP gönderim işlemi başarısız: ', x);
                alert(this.translate('errors.kepSendFailed'));
            }).then(() => {
                this.loading = false;
                this.isSignaturePanelVisible = false;
                this.isMobilePanelVisible = false;
                this.processingMessage = null;
            }); 
        },
        documentSigningCompleted(){
            // Dosyaların imzalanması tamamlandığında sunucu tarafında kabul işlemini başlatır.
            // Bu metodu imzalayıcı componenti @complete eventinde tetikler
            this.loading = true;

            this.processingMessage = this.translate('processingMessages.docsProcessing')
            this.$forceUpdate();

            var descriptionQuery = this.description ? `?description=${this.description}` : '';

            axios.get(`/job/acceptSignedFiles/${this.data.Id}${descriptionQuery}`).then(x => {
                if(x.data.Success) {
                    this.$alert(this.translate('messages.signSuccess'),this.translate('messages.success2'),"success");
                    this.$router.push({ name:'JobMyList' });
                } else {
                    alert(x.data.ErrorMessages);
                    this.$refs.imzalayici.loading = false;
                }
            }).catch(x => {
                console.warn('Dosya kabul işlemi başarısız: ', x);
                alert(this.translate('errors.signAcceptFailed'));
            }).then(() => {
                this.loading = false;
                this.isSignaturePanelVisible = false;
                this.isMobilePanelVisible = false;
                this.processingMessage = null;
            });
        },
        showSignaturePanel(){
            // Token imza panelini açar
            if(!this.$root.$data.login.User.IdentityNumber) {
                if(confirm(this.translate('warnings.identityMissing'))) {
                    this.$router.push({ name:'UserIdentity', params: { id: this.$root.$data.login.User.Id } });
                }
                return;
            }

            axios.get(`/Job/CheckSigner/${this.data.Id}`).then(() => {  
                this.sendRemFinalizer = null;
                this.signingCompletedFunction = this.documentSigningCompleted;
                this.signingItems = this.data.Documents.map(x => ({
                DocumentId : x.Id,
                SignatureFormat : x.SignatureFormat,
                FileName : x.UnsignedFile.FileName,
                Size : x.UnsignedFile.Size,
                State : '',
                GetUrl: `/Job/ContentForSign?jobId=${this.data.Id}&documentId=${x.Id}`,
                PostUrl: '/Job/ContentForSign',
                PostParams: { JobId: this.data.Id, DocumentId: x.Id }
            }));
            this.isSignaturePanelVisible = true;  
            }).catch(() => {
                alert(this.translate('errors.cantSignAlreadySigned:'+ this.data.TrackingNo.Serial + ':' + this.data.TrackingNo.Number));
            }) 




        },
        showMobilePanel(){
            if(!this.$root.$data.login.User.IdentityNumber) {
                if(confirm(this.translate('warnings.identityMissing'))) {
                    this.$router.push({ name:'UserIdentity', params: { id: this.$root.$data.login.User.Id } });
                }
                return;
            }

            axios.get(`/MobileSign/CheckSigner/${this.data.Id}`).then(x => {  
                console.log(x);             
                 // Mobil imza panelini açar
            this.signingCompletedFunction = this.documentSigningCompleted;
            this.mobileItems = this.data.Documents.map(x => ({
                DocumentId : x.Id,
                SignatureFormat : x.SignatureFormat,
                FileName : x.UnsignedFile.FileName,
                Size : x.UnsignedFile.Size,
                State : '',
                FingerprintUrl: `/MobileSign/CalculateFingerprint/${this.data.Id}?documentId=${x.Id}`,
                PostUrl: `/MobileSign/Sign/${this.data.Id}?documentId=${x.Id}&fingerPrintTempFileId={0}`,
                PostParams: { JobId: this.data.Id, DocumentId: x.Id }
            }))
            this.isMobilePanelVisible = true;           
            }).catch(x => {
                alert(this.translate('errors.cantSignAlreadySigned:'+ this.data.TrackingNo.Serial + ':' + this.data.TrackingNo.Number));
                console.log(x);
            })
        },  
        requestMaker(url, emptyPostData = false, redirectUrl = false) {
            let postData = {};
            if (!emptyPostData) {
                if (!this.description) {
                    alert(this.translate('warnings.pleaseEnterDescription'));
                    return;
                }
                postData.JobId = this.$route.params.id;
                postData.Description = this.description;
            }

            this.loading = true;
            this.axios.post(url, postData).then(response => {
                    console.log("POST Result:", response.data); 

                    if (response.data.Success) {
                        if(redirectUrl) {
                            this.$router.push({ name: "DraftDetail", params:{ id: response.data.Data.DraftId } });
                        } else { 
                            this.description = '';
                            this.data = response.data.Data.Job;
                            this.userActions = response.data.Data.UserActions;
                        }
                    } else {
                        alert(response.data.ErrorMessages)
                    } 
                })
                .catch(x => window.processErrorResponse(x, this))
                .then(() => {
                    this.loading = false;
                });
        },
        //Düzenle ve yeniden başlat
        copy(){
            this.requestMaker('draft/createByJobReference/' + this.$route.params.id, true,true);
        },
        //Benzer iş kopyası oluşturur.
        clone(){
            this.requestMaker('job/clone/' + this.$route.params.id, true,true);
        },
        revise(){
            this.$router.push({ name: 'JobRevise', params: { id: this.$route.params.id } });
        },
        cancel(){
            if(!this.description) {
                alert(this.translate('warnings.pleaseDefineCancelReason'));
                return;
            }

            if(confirm(this.translate('warnings.sureToCancel'))){
                this.requestMaker('job/cancel');
            }
        },
        undoCancel(){
            if(confirm(this.translate('warnings.sureToUndoCancel'))){
                this.requestMaker('job/undocancel');
            }
        },
        decline(){
            // İşi reddeder
            if(!this.description) {
                alert(this.translate('warnings.pleaseDefineDenyReason'));
                return;
            }

            this.loading = true;
            var url = `/job/decline/`;

            return axios
              .post(url, { JobId: this.$route.params.id, description: this.description })
              .then(x => {
                console.log("POST Result:", x.data);

                if(x.data.Success) {
                    this.data = x.data.Data.Job;
                    this.userActions = x.data.Data.UserActions;
                    this.description = '';
                } else {
                    alert(x.data.ErrorMessages)
                }

                this.loading = false;
              })
              .catch(x => window.processErrorResponse(x, this));
        },
        approve(){
            // İşi onaylar
            if(!this.approveCheck)
            {
                alert(this.translate('warnings.selectApproveBox'))
                return;
            }
            
            this.loading = true;
            var url = `/job/approve/`;
            
            axios
              .post(url, { JobId: this.$route.params.id, description: this.description ?? "" })
              .then(x => {
                console.log("POST Result:", x.data);
                this.loading = false;
                if(x.data.ErrorMessage){
                    alert(x.data.ErrorMessage);
                }
                else if(x.data.Data.SessionId){
                    this.validationResult = x.data.Data;
                    this.isOTPPanelVisible = true
                    console.log(this.validationResult)
                }
                else if(x.data.Success) {
                    this.data = x.data.Data.Job;
                    this.userActions = x.data.Data.UserActions;
                    this.description = null;
                    this.approveCheck = false;
                    this.$alert(this.translate('messages.approveSuccess'),this.translate('messages.success2'),"success");
                    this.$router.push({ name:'JobMyList' });
                } else {
                    alert(x.data.ErrorMessages)
                }

              })
              .catch(x => {
                console.log(x);
                alert(x.Message)
                window.processErrorResponse(x, this);
                
                this.loading = false;
            });
            this.loading = false;
        },
        validate(){
            this.loading = true;
            this.processingMessage = this.translate('processingMessages.identifying')
            var url = `/job/ApproveOTPJob/`;
            axios.post(url, {SessionId: this.validationResult.SessionId , OTP: this.approveForm.OTP, JobId: this.$route.params.id, description: this.description ?? "" })
            .then(x => {
                if(x.data.Success){
                    console.log("Başarılı")
                    this.data = x.data.Data.Job;
                    this.userActions = x.data.Data.UserActions;
                    this.description = null;
                    this.approveCheck = false;
                    this.$alert(this.translate('messages.approveSuccessLog'),this.translate('messages.success2'),"success");
                    this.$router.push({ name:'JobMyList' });
                } else{
                    alert(x.data.ErrorMessages)
                }
            this.loading = false;
            this.isOTPPanelVisible = false;
            })
            .catch(x => window.processErrorResponse(x, this));
        },
        getData(id){
            // Id numarası verilen iş bilgilerini çeker
            this.loading = true;
            var url = `/job/getwithactions/${id}`;

            return axios
              .get(url)
              .then(x => {
                console.log("POST Result:", x.data);
                this.data = x.data.Data.Job;
                this.userActions = x.data.Data.UserActions;
                this.loading = false;
              })
              .catch(x => {
                  window.processErrorResponse(x, this);
                  this.$router.go(-1);
                  //console.log('Hata aldık, geri git.');
              });
        },
        downloadDocument(document, menuKey){
            // İndirilecek doküman için dinamik URL'i alır ve tarayıcıyı bu adrese yönlendirir.
            return axios
              .post(`/job/createDocumentUrl/`, {
                  EntityId : this.data.Id,
                  DocumentId: document.Id,
                  IsSigned: menuKey == 'downloadSigned' ? true : false,
                  IsFormatted: menuKey == 'downloadFormatted' ? true : false,
              })
              .then(x => {
                console.log("createDocumentUrl Result:", x.data);
                window.open(x.data.Data.Url + (menuKey == 'view' ? "&view=true" : ""));
              })
              .catch(x => window.processErrorResponse(x, this));
        },
        downloadAttachment(attachment, menuKey){
            // İndirilecek ek dosya için dinamik URL'i alır ve tarayıcıyı bu adrese yönlendirir.
            return axios
              .post(`/job/createAttachmentUrl/`, {
                  EntityId : this.data.Id,
                  AttachmentId: attachment.Id
              })
              .then(x => {
                console.log("createAttachmentUrl Result:", x.data);
                window.open(x.data.Data.Url + (menuKey == 'view' ? "&view=true" : ""));
              })
              .catch(x => {
                  switch(x.response.status) {
                      case 404:
                        alert(this.translate('errors.noRecord'));
                        break;
                    default:
                        this.errorMessage = "İşlem gerçekleştirilemedi: " + x;
                        break;
                  }
                  this.loading = false;
              });
        },
        print(){
            console.log(this.data)
        },
        downloadLog(stepIndex){
            return axios
              .post(`/job/CreateOTPDocumentUrl/`, {
                  DocumentId : stepIndex,
                  EntityId: this.data.Id
              })
              .then(x => {
                console.log("createDocumentUrl Result:", x.data);
                window.open(x.data.Data.Url);
              })
              .catch(x => window.processErrorResponse(x, this));
        },
        document(isShow){
        return axios.post('/document/post' ,  this.data)
        .then(x => {
            console.log("createDocumentUrl Result:", x.data);
            
            if(isShow)
            {
                
                // this.pdfURL = x.data.Data.Url + "&view=false" ;
                this.pdfURL =  "https://testapi.izonay.com/test/demopdf.pdf";
                console.log(this.pdfURL);
                // this.$refs.pdfComponet.src = this.pdfURL;
                //this.$refs.pdfComponet.pdfurl = this.pdfURL;
                this.$refs.pdfComponent.show();
                //window.open(x.data.Data.Url + "&view=" + isShow + "#toolbar=0" , "popup");
            }
            else
            {
                window.open(x.data.Data.Url + "&view=" + isShow);
            }
            this.refreshCaptcha().then(() => {
                this.loading = false;
            });          
        })
        .catch(x => window.processErrorResponse(x, this));
    }     
    },
    computed: {
        jobStatusLabel(){
            if(!this.data || !this.data.State)
                return null;
            return this.$izonay.jobStatus[this.data.State]?.text;
        },
        jobStatusClass(){
            if(!this.data || !this.data.State)
                return null;

            return this.$izonay.jobStatus[this.data.State]?.css;
        },
        identityNumber(){   // Oturumu açık kullanıcının T.C. kimlik numarası
            console.log("TCKN:", this.$root.$data.login.User.IdentityNumber);
            return this.$root.$data.login.User.IdentityNumber;
            //return this.$root.$data.login.user.
        },
        isAdmin(){
            return this.hasAuth('Admin');
        },
        hideMobileSign(){
            if(!this.isOnPrem)
                return false;
                
            return window.settings.customization?.hideMobileSign ?? false;
        },
        isFilePattern(){
            var filePatternFound = true;
            this.data.Finalizers.forEach(finalizer => {
                if(finalizer.TargetSystem.DocumentFormat == null || finalizer.TargetSystem.DocumentFormat == 'None'){
                    filePatternFound = false;
                }
            });
            return filePatternFound;
        }
    }
    
}
</script>

<style scoped>
.xd{
    min-width: 45vw !important;
}
@media screen and (max-width:768px) {
    .job-container{
        display: flex;
        flex-direction: column;
    }
    .onlyMobileVisible{
        display: block !important;
    }
}
@-moz-document url-prefix() {
    @media screen and (max-width:1400px) {
    .job-container{
        display: flex;
        flex-direction: column;
    }
   
    .onlyMobileVisible{
        display: block !important;
    }
}
}
.onlyMobileVisible{
    display: none;
    margin-left: 10px;
}
.job-actions .btn{
    margin-left: 10px;
}

.job-actions .btn:first-child {
    margin-left:0;
}

.col-left{
    display: flow-root;
    width: 95%;
}
.flow-picture {
    width:1.4em;
    height:1.4em;
    vertical-align:middle;
    margin-right:4px;
    border-radius: 1.2em;
}
.signature-format-cell
{
    width:30px;
}
.cursor-default{
    cursor: default;
}

.damga-vergisi-group{
    display: flex;
    align-items: center;
    justify-content: flex-start;
}
.damga-vergisi-input{
  outline: 0;
  border-width: 0 0 2px;
  border-color: rgb(221, 221, 221)
}
.damga-vergisi-input:focus {
  border-color: green
}
.damga-vergisi-input-select{
    padding-top: 6px;
  outline: 0;
  border-width: 0 0 2px;
  border-color: rgb(221, 221, 221)
}
.damga-vergisi-input-select:focus {
  border-color: green
}
.popper-button-template .btn{
    margin: 10px;
}
.custom-button-container{
    display: flex;
    flex-direction: row-reverse;
    z-index: 0;
    align-items: center;
    justify-content: center;
}
.footer-button-container-1{
    display: flex;
    align-items: center;
    justify-content: space-between !important;
}
</style>